







import { userModule } from "@/store/modules/user";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { calcBmiNumber, categoryBmiKemenkes } from "@/utils/rumus-kesehatan";

@Component({
  components: {},
})
export default class Imt extends Vue {
  @Prop() setBb: number;
  @Prop() setTb: number;

  get bmiNumber(): number | null {
    return calcBmiNumber(this.setTb, this.setBb);
  }

  get setImt(): string | number {
    return this.bmiNumber === null ? 0 : Number(this.bmiNumber.toFixed(2));
  }

  get imtDisplay(): string | number {
    return this.setImt;
  }

  get stateuser() {
    return userModule.user;
  }

  // Poli Anak (unit 06 / 2A) memakai Z-score, bukan IMT dewasa → sembunyikan kategori.
  get poliAnak(): boolean {
    return this.stateuser.unit_id === "06" || this.stateuser.unit_id === "2A";
  }

  get keterangan(): string {
    return categoryBmiKemenkes(this.bmiNumber, { isPediatric: this.poliAnak });
  }

  @Watch("setImt", { immediate: true })
  emitImt(v: string | number) {
    this.$emit("imt", v);
  }
}
